import { useSearchParams } from "react-router-dom";

export const useSearchNavigation = () => {
    const [searchParams] = useSearchParams();

    return searchParams.get("navigationKey")?.startsWith("navigation");
};
